import React from "react";
import { Route } from "react-router-dom";




// import ViewResume from "./viewResume/viewResume";
import  ViewUploadedResume from './uploadedresume/mainPart'
import Dashnavigation from "../dashboard/navigation/dashbnavigation";
import ChangePassword from '../my_profile/change_password/ChangePassword'
import Myprofile from "../my_profile/MyProfile";
import PublishedJobs from "../jobs/jobs"
import MatchedJobs from "../jobs/matched_jobs";
import ViewApplyJobs from "../issights/viewApplyJobs"; 
// import SummaryResume from "../my_profile/summary-resume/SummaryResume"
import PrintSummary from "../my_profile/summary-resume/PrintSummary"

import PdfRender from "./PrintPdf/PdfRender";
// component for executing routes after login

const Collection = () => {
  // let history = useHistory();
 

  // const checkingCurrentUser = () => {
  //   axios
  //     .get(`${API_AUTH}/v1/api/auth/isLoggedIn`, { withCredentials: true })
  //     .then((response) => {
  //       console.log(response.status);
  //     })
  //     .catch((err) => {
  //       console.log({ err });
  //       if (err.response && err.response.data.statusCode === 403) {
  //         history.push({
  //           pathname: "/signin",
  //         });
  //       }
  //     });
  // };

  /**
   * This function to avoid the browser back button after user login to the website if he click on the back  button without logout it won't go back to home page.
   */
  // componentDidMount() {
  //     function preback() {
  //         window.history.forward();
  //     }
  //     setTimeout(() => {
  //         preback();
  //     }, 0);
  //     window.onunload = function () {
  //         return null;
  //     };
  // }

  return (
    <div>
      <Dashnavigation />

      <Route exact path="/dashboard/my_profile" component={Myprofile} />
      {/* <Route exact path="/dashboard/viewResume" component={ViewResume} /> */}
      <Route exact path="/dashboard/PdfRender" component={PdfRender} />
      <Route exact path="/dashboard/uploadedResume" component ={ViewUploadedResume}/>
      <Route exact path="/dashboard/change_password" component = {ChangePassword}/>
      <Route exact path="/dashboard/published_jobs" component = {PublishedJobs}/>
      <Route exact path="/dashboard/matched_jobs" component = {MatchedJobs}/>
      <Route exact path="/dashboard/view_apply_jobs" component = {ViewApplyJobs}/>
      {/* <Route exact path="/dashboard/SummaryResume" component = {SummaryResume}/> */}
      <Route exact path="/dashboard/PrintSummary" component = {PrintSummary}/>
    </div>
  );
};
export default Collection;
